import styled, {css} from 'styled-components';

import {Icon} from 'components/ui-kit/Icon';
import {breakpoint, colors, font} from 'theme';

export const SettingsContainer = styled.div`
    display: flex;
    flex-flow: column wrap;
    font-family: ${font.family.primary};
    user-select: none;
    margin: 30px 0 0;
`;

export const GroupedSettingItem = styled.div`
    display: flex;
    flex-flow: column wrap;
    border-top: 1px solid ${colors.background};
    border-bottom: 1px solid ${colors.background};

    &.sortable-ghost {
        background-color: ${colors.background};
    }
`;

export const GroupedSettingHeader = styled.div`
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    margin-right: 20px;
    padding-top: 10px;
    cursor: grab;
    font-weight: 600;
`;

export const SettingItem = styled.div<{active: boolean; grouped?: boolean}>`
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;

    &.sortable-ghost {
        background-color: ${colors.background};
    }

    ${(p) =>
        !p.grouped
            ? css`
                  padding-top: 10px;
                  padding-bottom: 10px;
                  border-top: 1px solid ${colors.background};
                  border-bottom: 1px solid ${colors.background};
              `
            : css`
                  margin-left: 66px; // Align to GroupedSettingHeader text
              `}

    ${(p) =>
        !p.active &&
        css`
            opacity: 0.4;
        `}
`;

export const SettingMain = styled.div`
    display: flex;
    align-items: center;
    margin-left: 34px;
    cursor: grab;
`;

export const SettingNumber = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 38px;
    height: 38px;
    margin-right: 28px;
    font-weight: 600;
    background-color: ${colors.background};
    border-radius: 50%;
`;

export const SettingControls = styled.div`
    display: flex;
    align-items: center;
    margin-right: 14px;
`;

export const DraggableIcon = styled(Icon)`
    margin-left: 10px;
    cursor: grab;
`;

export const ActionsContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 20px;
    font-family: ${font.family.primary};

    > button {
        width: auto;

        &:not(:last-of-type) {
            margin-right: 10px;
        }
    }
`;
